import * as z from "zod";

/** Disco's store categories, for the connect form. */
export const listDiscoCategories = {
  name: "listDiscoCategories" as const,
  input: z.null(),
  output: z.object({
    categories: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        subcategories: z.array(z.object({ id: z.string(), name: z.string() })),
      }),
    ),
  }),
};
